import { SortTypes } from "util/table-view/TableTypes";
import { actionTypes } from "./CueSheetCFContentActions";
import { MBTrackUsageMapping, getDurationValue, getSocietyIndicator, getTimeToSeconds, standardMusicOriginType, timeToSeconds, validOriginForCatNoChange } from "../Types";
import { durationPickerType } from "redux/Types";
import { deepCopyFunction } from "util/CommonFunc";

const getMusicOriginMappings = (trackOrigin) => {
  let origin = standardMusicOriginType.MusicVideo;
  switch (trackOrigin) {
    case "library_non_mechanical":
      origin = standardMusicOriginType.ProductionLibraryNonMechanical;
      break;
    case "library":
      origin = standardMusicOriginType.ProductionMusic;
      break;
    case "satv_library":
      origin = standardMusicOriginType.SATVLibrary;
      break;
    case "spec_comm_satv_publ_only":
      origin = standardMusicOriginType.SpecCommSatvPublOnly;
      break;
    case "spec_comm_satv_publ_other":
      origin = standardMusicOriginType.SpecCommSatvPublOther;
      break;
    case "video":
      origin = standardMusicOriginType.MusicVideo;
      break;
    case "tv_soundtrack":
      origin = standardMusicOriginType.TVSoundtrack;
      break;
    case "film_soundtrack":
      origin = standardMusicOriginType.FilmClip;
      break;
    case "commercial":
      origin = standardMusicOriginType.Commercial;
      break;
    case "live":
      origin = standardMusicOriginType.LivePerformance;
      break;
    case "commissioned":
      origin = standardMusicOriginType.SpecCommNonSatvPubl;
      break;
    case "unknown":
      origin = standardMusicOriginType.Unknown;
      break;
    case "sound_fx":
      origin = standardMusicOriginType.TVSoundtrack;
      break;
    case "actuality":
      origin = standardMusicOriginType.Actuality;
      break;
    case "concert_footage":
      origin = standardMusicOriginType.ConcertFootage;
      break;
    case "film_clip":
      origin = standardMusicOriginType.FilmClip;
      break;
    case "programme_clip":
      origin = standardMusicOriginType.ProgrammeClip;
      break;
    case "studio_footage":
      origin = standardMusicOriginType.StudioFootage;
      break;
    default:
      origin = "";
  }
  return origin
}

const initialTrackUsage = {

  "description": "",
  "duration": "",
  "occurrences": "",
  "start_time": "",
  "end_time": "",
  "society_indicator": 0 //added for temp
  ,
}

const initialState = {
  wizard: { ids: [], copyLive: false },
  items: [],
  copyOfItems: [],
  timecodeSortedItems: [],
  selectedItem: {},
  selectedItems: [],
  cueSheet: {
  },
  sessionId: "",
  loading: false,
  loadingPage: false,
  loadingMore: false,
  timeCodeSorting: false,
  isTimeCodeSortUpdated: false,
  shouldTimeCodeSortUpdate: false,
  noMore: true,
  posting: { busy: false, message: "", errors: null, trackErrors: null },
  postingLocal: { busy: false, message: "", errors: null },
  validating: { busy: false },
  editing: null,
  query: {
    order: SortTypes.desc,
    orderBy: "updatedAt",
    page: 0,
    size: 10000,
    q: "",
    filters: [],
  },
  errors: null,
  history: {},
  changedFields: [],
  changedTrackFields: [],
  cueData: {
    clearance_tracks: []
  },
  activePreview: 0,
  cfTracks: {},
  cfTracksLoading: false,
  _statuses: [],
  _parameters: [],
  tracksPosting: { busy: false, message: "", errors: null },
  sortValue: "",
};

export default function (state = initialState, action) {

  switch (action.type) {
    case actionTypes.OPENWIZARD:
      return {
        ...state,
        wizard: action.payload,
      };
    case actionTypes.LOADING:
      return {
        ...state,
        loadingPage: true,
        errors: null,
        selectedItems: [],
        selectedItem: {},
        items: [],
        editing: null,
      };
    case actionTypes.LOAD:
      return {
        ...state,
        loadingPage: false,
        editing: action.payload.data,
        items: action.payload.items,
        selectedItems: [],
        errors: null,
        selectedItem: (action.payload.items && action.payload.items.length > 0) ? action.payload.items[0] : null,
      };

    case actionTypes.EDITING:
      return {
        ...state,
        editing: action.payload,
      };
    case actionTypes.SET_CUESHEET:
      return {
        ...state,
        cueSheet: action.payload,
        timeCodeSorting: false,
        isTimeCodeSortUpdated: false
      };
    case actionTypes.SET_SESSIONID:
      return {
        ...state,
        sessionId: action.payload,
      };
    case actionTypes.SET_STATUSES:
      return {
        ...state,
        _statuses: action.payload,
        timeCodeSorting: false
      };
    case actionTypes.SET_PARAMETERS:
      return {
        ...state,
        _parameters: action.payload,
      };
    case actionTypes.ADD_CUE_DATA:

      let data = state.cueSheet;
      let i = state.items[state.items.findIndex(e => e.id == action?.payload.id)];
      let t = i.trackDetails;
      let extClearanceTrackIndex1 = data.cueData?.clearance_tracks.findIndex(e => e.clearance_track_id == t.id);
      let lastIndex = data.cueData?.clearance_tracks && extClearanceTrackIndex1 > -1 ? data.cueData.clearance_tracks[extClearanceTrackIndex1].clearance_track_usages.length - 1 : 0;
      if (data.cueData?.clearance_tracks && extClearanceTrackIndex1 > -1 && action?.payload.value != "") {
        let addNewLenth = action?.payload.value - data.cueData.clearance_tracks[extClearanceTrackIndex1].clearance_track_usages.length;
        for (let index = 1; index <= addNewLenth; ++index) {
          data.cueData.clearance_tracks[extClearanceTrackIndex1].clearance_track_usages.push(
            {
              "description": "",
              "duration": "",
              "occurrences": action?.payload.value,
              "start_time": "",
              "end_time": "",
              "society_indicator": getSocietyIndicator(i)
            }
          );


        }

        if (addNewLenth < 0) {
          data.cueData.clearance_tracks[extClearanceTrackIndex1].clearance_track_usages.length = data.cueData.clearance_tracks[extClearanceTrackIndex1].clearance_track_usages.length - Math.abs(addNewLenth)
        }
        data.cueData.clearance_tracks[extClearanceTrackIndex1].clearance_track_usages[0].occurrences = action?.payload.value;

      }
      else if (data.cueData?.clearance_tracks && extClearanceTrackIndex1 > -1 && data.cueData.clearance_tracks[extClearanceTrackIndex1].clearance_track_usages[lastIndex]?.duration != "" && !data.cueData.clearance_tracks[extClearanceTrackIndex1].clearance_track_usages[lastIndex].duration?.includes("NaN") && data.cueData.clearance_tracks[extClearanceTrackIndex1].clearance_track_usages[lastIndex].occurrences != "") {
        data.cueData.clearance_tracks[extClearanceTrackIndex1].clearance_track_usages.push(
          {
            "description": "",
            "duration": "",
            "occurrences": "1",
            "start_time": "",
            "end_time": "",
            "society_indicator": getSocietyIndicator(i)
          }
        );
      }
      else {
        data = data;

      }

      return {
        ...state,
        cueSheet: data,
      };
    case actionTypes.ADD_CUE_DATA_TIMECODE_SORT:

      let odata = { ...state.cueSheet };
      let iii = state.items.find(e => e.id === action?.payload.id);
      let tDetails = iii.trackDetails;
      let extClTrackIndex = odata.cueData?.clearance_tracks
        ?.findIndex(e => e.clearance_track_id === tDetails.id);
      if (extClTrackIndex > -1 && odata.cueData?.clearance_tracks) {
        let usages = odata.cueData.clearance_tracks[extClTrackIndex].clearance_track_usages;
        let parentSubUsages = odata.cueData.clearance_tracks[extClTrackIndex].clearance_track_usages.filter(e => e.parentUsageUniqueId == action?.payload.parentid)
        let lastIndex = usages.length - 1;
        let value = action?.payload.value;
        let parentSubUsagesLstIndex = parentSubUsages.length - 1;


        const createUsage = (occurrences) => {
          // collect all existing parentUsageIndex values
          const existingIndexes = usages
            .map(u => u.parentUsageIndex)
            .filter(idx => idx !== null && idx !== undefined);

          // find the next unique integer (start from 0 or 1 as you prefer)
          let nextIndex = 0;
          while (existingIndexes.includes(nextIndex)) {
            nextIndex++;
          }

          return {
            description: "",
            duration: "",
            occurrences,
            start_time: "",
            end_time: "",
            society_indicator: getSocietyIndicator(iii),
            usageSubIndex: nextIndex,
            parentUsageIndex: nextIndex,
            parentUsageUniqueId: action?.payload.parentid
          };

        };
        if (value !== "") {
          let diff = value - usages.length;

          if (diff > 0) {
            for (let i = 0; i < diff; i++) {
              usages.push(createUsage(value));
            }
          } else if (diff < 0) {
            // Only trim, never make length negative
            usages.splice(value);
          }

          if (usages[0]) {
            usages[0].occurrences = value;
          }
        }
        else if (
          parentSubUsages[parentSubUsagesLstIndex]?.duration &&
          !parentSubUsages[parentSubUsagesLstIndex].duration.includes("NaN")
          // &&
          // parentSubUsages[parentSubUsagesLstIndex].occurrences !== ""
        ) {
          odata.cueData.clearance_tracks[extClTrackIndex].clearance_track_usages.push(createUsage("1"));

        }

        // odata.cueData.clearance_tracks[extClTrackIndex].clearance_track_usages = usages;
      }
      return {
        ...state,
        cueSheet: odata
      };
    case actionTypes.REMOVE_CUE_DATA:

      let oData = state.cueSheet;
      let oItems = state.items;
      let usageIndex = action?.payload?.index;
      let trackId = action?.payload?.id;

      let ii = oItems.find(e => e.trackDetails?.id === trackId);
      let extClearanceTrackIndex2 = oData.cueData?.clearance_tracks.findIndex(e => e.clearance_track_id === trackId);
      let clearanceTrack = oData.cueData?.clearance_tracks?.[extClearanceTrackIndex2];
      let usageList = clearanceTrack?.clearance_track_usages;
      let usageExists = usageList?.[usageIndex];
      let bShouldTimeCodeSortUpdate = state.shouldTimeCodeSortUpdate;

      const isSingleUsage = usageList?.length === 1;
      const isLastIndex = usageIndex === usageList?.length - 1;
      const isFirstIndex = usageIndex === 0;
      const addedCount = usageList?.filter(ii => ii.added === true)?.length;

      if (
        (isFirstIndex && isSingleUsage && usageExists) ||
        (isLastIndex && usageExists && usageList?.length > 1)
      ) {
        usageList[usageIndex] = {
          ...usageList[usageIndex],
          description: "",
          duration: "",
          occurrences: "1",
          start_time: '',
          end_time: '',
          society_indicator: getSocietyIndicator(ii),
        };
      }
      else if (
        usageIndex &&
        usageList?.length &&
        usageExists &&
        addedCount === usageList?.length - 1
      ) {
        usageList[usageIndex] = {
          ...usageList[usageIndex],
          description: "",
          duration: "",
          occurrences: "1",
          start_time: '',
          end_time: '',
          society_indicator: getSocietyIndicator(ii),
        };
      }
      else if (usageExists) {
        usageList.splice(usageIndex, 1);
      }

      if (state.timeCodeSorting) {
        oItems = oItems.filter(item => item.usageUniqueId !== ii.usageUniqueId);
        bShouldTimeCodeSortUpdate = true;
      }

      return {
        ...state,
        cueSheet: oData,
        items: oItems,
        shouldTimeCodeSortUpdate: bShouldTimeCodeSortUpdate,
      };
    case actionTypes.REMOVE_SUB_CUE_DATA:

      let iData = state.cueSheet;
      let iItems = state.items;
      // let usageIndex = action?.payload?.index;
      let iTrackId = action?.payload?.id;

      let iTrack = iItems.find(e => e.trackDetails?.id === iTrackId);
      let iClearanceTrackIndex2 = iData.cueData?.clearance_tracks.findIndex(e => e.clearance_track_id === iTrackId);
      let iClearanceTrack = iData.cueData?.clearance_tracks?.[iClearanceTrackIndex2];
      let iUsageList = iClearanceTrack?.clearance_track_usages;
      let childUsageIndex = iData.cueData.clearance_tracks[iClearanceTrackIndex2].clearance_track_usages
        .findIndex(u => u.parentUsageUniqueId === action?.payload?.parentindex && u.parentUsageIndex == action?.payload.subindex);


      if (childUsageIndex) {
        iUsageList.splice(childUsageIndex, 1);
      }


      return {
        ...state,
        cueSheet: iData,
        shouldTimeCodeSortUpdate: true,
        // items: oItems,
      };

    case actionTypes.ADD_VALUE:

      let oValData = { ...state.cueSheet };
      let item = state.items[state.items.findIndex(e => e.id == action?.payload?.id)];
      let track = item.trackDetails;
      let selecteditems = state.selectedItems;
      let selectedItemindex = state.selectedItems.findIndex(i => i == action?.payload?.id);

      let extClearanceTrackIndex = oValData.cueData?.clearance_tracks.findIndex(e => e.clearance_track_id == track.id);
      if (oValData.cueData?.clearance_tracks && extClearanceTrackIndex > -1) {
        if (oValData.cueData.clearance_tracks[extClearanceTrackIndex].clearance_track_usages[action?.payload?.index]) {
          oValData.cueData.clearance_tracks[extClearanceTrackIndex].clearance_track_usages[action?.payload?.index][action.payload?.field] = action.payload?.field == "duration" ? `00:${action?.payload?.value.mm ? action?.payload?.value.mm : ''}:${action?.payload?.value.ss ? action?.payload?.value.ss : ''}` : action?.payload?.value;

          if (selectedItemindex > -1 && oValData.cueData.clearance_tracks[extClearanceTrackIndex].clearance_track_usages.filter(item => item.duration == "" || item.duration == "00:00:00").length > 0) {
            selecteditems.splice(selectedItemindex, 1);
          }

          if (action.payload?.field == "duration" && oValData.cueData.clearance_tracks[extClearanceTrackIndex].clearance_track_usages[action?.payload?.index]["duration"] != "00:00:00" && oValData.cueData.clearance_tracks[extClearanceTrackIndex].clearance_track_usages[action?.payload?.index]["occurrences"] == "") {
            oValData.cueData.clearance_tracks[extClearanceTrackIndex].clearance_track_usages[action?.payload?.index]["occurrences"] = "1";
          }

          if (!oValData.cueData.clearance_tracks[extClearanceTrackIndex].clearance_track_usages[action?.payload?.index].hasOwnProperty("isLocal")) {
            oValData.cueData.clearance_tracks[extClearanceTrackIndex].clearance_track_usages[action?.payload?.index]["isLocal"] = true;
          }

        }
        else {
          oValData.cueData.clearance_tracks[extClearanceTrackIndex].clearance_track_usages.push(
            {
              "description": action.payload?.field == "description" ? action?.payload?.value : "",
              "duration": action.payload?.field == "duration" ? `00:${action?.payload?.value.mm ? action?.payload?.value.mm : ''}:${action?.payload?.value.ss ? action?.payload?.value.ss : ''}` : "",
              "occurrences": action.payload?.field == "occurrences" ? action?.payload?.value : "",
              "society_indicator": getSocietyIndicator(item)
            }
          );

        }

      }
      else {
        if (!oValData['cueData']) {
          oValData['cueData'] = {
            clearance_tracks: []
          }
        };

        let clTrack = {
          clearance_track_id: track.id,
          clearance_track_usages: [{
            "description": action.payload?.field == "description" ? action?.payload?.value : "",
            "duration": action.payload?.field == "duration" ? `00:${action?.payload?.value.mm ? action?.payload?.value.mm : '00'}:${action?.payload?.value.ss ? action?.payload?.value.ss : '00'}` : "",
            "occurrences": action.payload?.field == "occurrences" ? action?.payload?.value : "",
            "society_indicator": getSocietyIndicator(item)
          }],
          track_title: track.prsTrack && track.prsTrack.trackTitle ? track.prsTrack.trackTitle : track.trackTitle,
          composers: track.prsTrack && track.prsTrack.composer ? track.prsTrack.composer : track.composer || [],
          publishers: track.prsTrack && track.prsTrack.publisher ? track.prsTrack.publisher : track.publisher || [],
          performers: track.prsTrack && track.prsTrack.performer ? track.prsTrack.performer : track.performer || [],
          isrc: track.prsTrack && track.prsTrack.isrc ? track.prsTrack.isrc : track.isrc,
          iswc: track.iswc,
          catalogue_number: track.prsTrack && track.prsTrack.catNo ? track.prsTrack.catNo : track.catNo,
          arrangers: track.arranger,
          record_or_video_labels: track.prsTrack && track.prsTrack.recordLabel ? track.prsTrack.recordLabel : track.recordLabel,
          music_origin: getMusicOriginMappings(track.musicOrigin),
          cue_usage: item['trackUsage'] && item['trackUsage'] != "" ? MBTrackUsageMapping.find(e => item.trackUsage == e.value)?.MLMapping || "F" : "F",
          mcps_status: track.org_sky_MCPS && track.org_sky_MCPS == true ? "CH" : track.org_sky_MCPS && track.org_sky_MCPS == false ? "UC" : "UK",
          album_title: track.prodName ? track.prodName : "",
          // album_id: track.prodId ? track.prodId : "",
          album_id: track.id || "",
          library_id: track.libId ? track.libId : "",
          library_name: track.libName ? track.libName : "",
        }

        if (
          validOriginForCatNoChange.includes(clTrack.music_origin) &&
          (!clTrack.catalogue_number || clTrack.catalogue_number.trim() === "")
        ) {
          if (clTrack.isrc && clTrack.isrc.trim() !== "") {
            clTrack.catalogue_number = clTrack.isrc; // copy ISRC into Cat No
          } else {
            clTrack.catalogue_number = "Unknown";
          }
        }
        oValData.cueData.clearance_tracks.push(clTrack);
      }


      return {
        ...state,
        cueSheet: oValData,
        isTimeCodeSortUpdated: false,
        selectedItems: selecteditems
      };
    case actionTypes.ADD_VALUE_TIMECODE_ADDITIONAL:

      let oValTData = { ...state.cueSheet };

      let titem = state.items.find(e => e.id == action?.payload?.id);
      let tTrack = titem.trackDetails;
      let timeCodeUpdate = state.isTimeCodeSortUpdated;


      let parentTrackIndex = oValTData.cueData?.clearance_tracks.findIndex(e => e.clearance_track_id == tTrack.id);

      if (parentTrackIndex > -1) {
        let childUsageIndex = oValTData.cueData.clearance_tracks[parentTrackIndex].clearance_track_usages
          .findIndex(u => u.parentUsageUniqueId === action?.payload?.parentindex && u.parentUsageIndex == action?.payload.subindex);

        let childtUsage = oValTData.cueData.clearance_tracks[parentTrackIndex].clearance_track_usages[childUsageIndex];
        if (childtUsage) {
          if (action?.payload.field === "duration") {
            oValTData.cueData.clearance_tracks[parentTrackIndex].clearance_track_usages[childUsageIndex].duration = `00:${action?.payload?.value.mm ?? '00'}:${action?.payload?.value.ss ?? '00'}`;
            timeCodeUpdate = true;
          } else {
            oValTData.cueData.clearance_tracks[parentTrackIndex].clearance_track_usages[childUsageIndex][action?.payload?.field] = action?.payload?.value;
          }

          if (!oValTData.cueData.clearance_tracks[parentTrackIndex].clearance_track_usages[childUsageIndex].hasOwnProperty("isLocal")) {
            oValTData.cueData.clearance_tracks[parentTrackIndex].clearance_track_usages[childUsageIndex]["isLocal"] = true;
          }

        } else {
          oValTData.cueData.clearance_tracks[parentTrackIndex].clearance_track_usages[childUsageIndex] = {
            description: action?.payload?.field === "description" ? action?.payload?.value : "",
            duration: action?.payload?.ield === "duration" ? `00:${action?.payload?.value.mm ?? '00'}:${action?.payload?.value.ss ?? '00'}` : "",
            occurrences: action?.payload?.field === "occurrences" ? action?.payload?.value : "",
            society_indicator: getSocietyIndicator(titem),
            parentUsageUniqueId: action?.payload?.parentindex,
            // usageSubIndex: childUsageIndex,
            parentUsageIndex: childUsageIndex
          };
        }
      }





      return {
        ...state,
        isTimeCodeSortUpdated: timeCodeUpdate,
        cueSheet: oValTData,
        // selectedItems: selecteditems
      };
    case actionTypes.ADD_TIMECODE_ADDITIONAL:

      let oValpData = { ...state.cueSheet };
      let pItem = state.items[state.items.findIndex(e => e.id == action?.payload?.id)];
      let pTrack = pItem.trackDetails;
      let selecteditems2 = state.selectedItems;
      let selectedItemindex2 = state.selectedItems.findIndex(i => i == action?.payload?.id);
      // Find clearance track index
      let pExtTrackIndex3 = oValpData.cueData?.clearance_tracks.findIndex(
        e => e.clearance_track_id == pTrack.id
      );
      if (oValpData.cueData?.clearance_tracks && pExtTrackIndex3 > -1) {

        let childUsageIndex = oValpData.cueData.clearance_tracks[pExtTrackIndex3].clearance_track_usages
          .findIndex(u => u.parentUsageUniqueId === action?.payload?.parentindex && u.parentUsageIndex == action?.payload.subindex);

        let childtUsage = oValpData.cueData.clearance_tracks[pExtTrackIndex3].clearance_track_usages[childUsageIndex];
        if (childtUsage) {
          oValpData.cueData.clearance_tracks[pExtTrackIndex3].clearance_track_usages[childUsageIndex]["start_time"] = action?.payload?.value.inTime || '';
          oValpData.cueData.clearance_tracks[pExtTrackIndex3].clearance_track_usages[childUsageIndex]["end_time"] = action?.payload?.value.outTime || '';

          if (!oValpData.cueData.clearance_tracks[pExtTrackIndex3].clearance_track_usages[childUsageIndex].hasOwnProperty("isLocal")) {
            oValpData.cueData.clearance_tracks[pExtTrackIndex3].clearance_track_usages[childUsageIndex]["isLocal"] = true;
          }
          // Remove from selected items if empty duration
          if (
            selectedItemindex2 > -1 &&
            oValpData.cueData.clearance_tracks[pExtTrackIndex3].clearance_track_usages.filter(item => item.duration == "" || item.duration == "00:00:00").length > 0
          ) {
            selecteditems2.splice(selectedItemindex2, 1);
          }
        }
        else {
          // Push new usage
          oValpData.cueData.clearance_tracks[pExtTrackIndex3].clearance_track_usages.push({
            "description": action.payload?.field == "description" ? action?.payload?.value : "",
            "duration": action.payload?.field == "duration"
              ? `00:${action?.payload?.value.mm ?? '00'}:${action?.payload?.value.ss ?? '00'}`
              : "",
            "occurrences": action.payload?.field == "occurrences" ? action?.payload?.value : "",
            "start_time": action?.payload?.value.inTime || '',
            "end_time": action?.payload?.value.outTime || '',
            "society_indicator": getSocietyIndicator(pItem),
            "parentUsageUniqueId": action?.payload?.parentindex || null,
            "parentUsageIndex": oValpData.cueData.clearance_tracks[pExtTrackIndex3].clearance_track_usages.length // assign index at push time
          });
        }
      }
      else {
        // If cueData doesn't exist, create it
        if (!oValpData['cueData']) {
          oValpData['cueData'] = { clearance_tracks: [] };
        }

        let clTrack = {
          clearance_track_id: pTrack.id,
          clearance_track_usages: [{
            "description": action.payload?.field == "description" ? action?.payload?.value : "",
            "duration": action.payload?.field == "duration"
              ? `00:${action?.payload?.value.mm ?? '00'}:${action?.payload?.value.ss ?? '00'}`
              : "",
            "occurrences": action.payload?.field == "occurrences" ? action?.payload?.value : "",
            "start_time": "",
            "end_time": "",
            "society_indicator": getSocietyIndicator(pItem),
            "parentUsageUniqueId": action?.payload?.parentindex || null,
            "parentUsageIndex": oValpData.cueData.clearance_tracks[pExtTrackIndex3].clearance_track_usages.length
          }],
          track_title: pTrack.prsTrack?.trackTitle || pTrack.trackTitle,
          composers: pTrack.prsTrack?.composer || pTrack.composer || [],
          publishers: pTrack.prsTrack?.publisher || pTrack.publisher || [],
          performers: pTrack.prsTrack?.performer || pTrack.performer || [],
          isrc: pTrack.prsTrack?.isrc || pTrack.isrc,
          iswc: pTrack.iswc,
          catalogue_number: pTrack.prsTrack?.catNo || pTrack.catNo,
          arrangers: pTrack.arranger,
          record_or_video_labels: pTrack.prsTrack?.recordLabel || pTrack.recordLabel,
          music_origin: getMusicOriginMappings(pTrack.musicOrigin),
          cue_usage: pTrack.trackUsage
            ? MBTrackUsageMapping.find(e => pTrack.trackUsage == e.value)?.MLMapping || "F"
            : "F",
          mcps_status:
            track1.org_sky_MCPS === true ? "CH" :
              track1.org_sky_MCPS === false ? "UC" : "UK",
          album_title: pTrack.prodName || "",
          album_id: pTrack.id || "",
          library_id: pTrack.libId || "",
          library_name: pTrack.libName || "",
        };

        if (
          validOriginForCatNoChange.includes(clTrack.music_origin) &&
          (!clTrack.catalogue_number || clTrack.catalogue_number.trim() === "")
        ) {
          if (clTrack.isrc && clTrack.isrc.trim() !== "") {
            clTrack.catalogue_number = clTrack.isrc; // copy ISRC into Cat No
          } else {
            clTrack.catalogue_number = "Unknown";
          }
        }
        oValpData.cueData.clearance_tracks.push(clTrack);
      }



      return {
        ...state,
        isTimeCodeSortUpdated: true,
        cueSheet: oValpData,
        // selectedItems: selecteditems
      };


    case actionTypes.ADD_TIMECODE:
      let oValData1 = { ...state.cueSheet };
      let item1 = state.items[state.items.findIndex(e => e.id == action?.payload?.id)];
      let track1 = item1.trackDetails;
      let selecteditems1 = state.selectedItems;
      let selectedItemindex1 = state.selectedItems.findIndex(i => i == action?.payload?.id);
      let extClearanceTrackIndex3 = oValData1.cueData?.clearance_tracks.findIndex(e => e.clearance_track_id == track1.id);
      if (oValData1.cueData?.clearance_tracks && extClearanceTrackIndex3 > -1) {
        if (oValData1.cueData.clearance_tracks[extClearanceTrackIndex3].clearance_track_usages[action?.payload?.index]) {
          oValData1.cueData.clearance_tracks[extClearanceTrackIndex3].clearance_track_usages[action?.payload?.index]["start_time"] = action?.payload?.value.inTime ? action?.payload?.value.inTime : '';
          oValData1.cueData.clearance_tracks[extClearanceTrackIndex3].clearance_track_usages[action?.payload?.index]["end_time"] = action?.payload?.value.outTime ? action?.payload?.value.outTime : '';

          if (selectedItemindex1 > -1 && oValData1.cueData.clearance_tracks[extClearanceTrackIndex3].clearance_track_usages.filter(item => item.duration == "" || item.duration == "00:00:00").length > 0) {
            selecteditems1.splice(selectedItemindex1, 1);
          }

          if (!oValData1.cueData.clearance_tracks[extClearanceTrackIndex3].clearance_track_usages[action?.payload?.index].hasOwnProperty("isLocal")) {
            oValData1.cueData.clearance_tracks[extClearanceTrackIndex3].clearance_track_usages[action?.payload?.index]["isLocal"] = true;
          }

        }
        else {
          oValData1.cueData.clearance_tracks[extClearanceTrackIndex3].clearance_track_usages.push(
            {
              "description": action.payload?.field == "description" ? action?.payload?.value : "",
              "duration": action.payload?.field == "duration" ? `00:${action?.payload?.value.mm ? action?.payload?.value.mm : '00'}:${action?.payload?.value.ss ? action?.payload?.value.ss : '00'}` : "",
              "occurrences": action.payload?.field == "occurrences" ? action?.payload?.value : "",
              "start_time": action?.payload?.value.inTime ? action?.payload?.value.inTime : '',
              "end_time": action?.payload?.value.outTime ? action?.payload?.value.outTime : '',
              "society_indicator": getSocietyIndicator(item1)
            }
          );

        }

      }
      else {
        if (!oValData1['cueData']) {
          oValData1['cueData'] = {
            clearance_tracks: []
          }
        };

        let clTrack = {
          clearance_track_id: track1.id,
          clearance_track_usages: [{
            "description": action.payload?.field == "description" ? action?.payload?.value : "",
            "duration": action.payload?.field == "duration" ? `00:${action?.payload?.value.mm ? action?.payload?.value.mm : '00'}:${action?.payload?.value.ss ? action?.payload?.value.ss : '00'}` : "",
            "occurrences": action.payload?.field == "occurrences" ? action?.payload?.value : "",
            "start_time": "",
            "end_time": "",
            "society_indicator": getSocietyIndicator(item1)
          }],
          track_title: track1.prsTrack && track1.prsTrack.trackTitle ? track1.prsTrack.trackTitle : track1.trackTitle,
          composers: track1.prsTrack && track1.prsTrack.composer ? track1.prsTrack.composer : track1.composer || [],
          publishers: track1.prsTrack && track1.prsTrack.publisher ? track1.prsTrack.publisher : track1.publisher || [],
          performers: track1.prsTrack && track1.prsTrack.performer ? track1.prsTrack.performer : track1.performer || [],
          isrc: track1.prsTrack && track1.prsTrack.isrc ? track1.prsTrack.isrc : track1.isrc,
          iswc: track1.iswc,
          catalogue_number: track1.prsTrack && track1.prsTrack.catNo ? track1.prsTrack.catNo : track1.catNo,
          arrangers: track1.arranger,
          record_or_video_labels: track1.prsTrack && track1.prsTrack.recordLabel ? track1.prsTrack.recordLabel : track1.recordLabel,
          music_origin: getMusicOriginMappings(track1.musicOrigin),
          cue_usage: item1['trackUsage'] && item1['trackUsage'] != "" ? MBTrackUsageMapping.find(e => item1.trackUsage == e.value)?.MLMapping || "F" : "F",
          mcps_status: track1.org_sky_MCPS && track1.org_sky_MCPS == true ? "CH" : track1.org_sky_MCPS && track1.org_sky_MCPS == false ? "UC" : "UK",
          album_title: track1.prodName ? track1.prodName : "",
          // album_id: track.prodId ? track1.prodId : "",
          album_id: track1.id || "",
          library_id: track1.libId ? track1.libId : "",
          library_name: track1.libName ? track1.libName : "",
        }

        if (
          validOriginForCatNoChange.includes(clTrack.music_origin) &&
          (!clTrack.catalogue_number || clTrack.catalogue_number.trim() === "")
        ) {
          if (clTrack.isrc && clTrack.isrc.trim() !== "") {
            clTrack.catalogue_number = clTrack.isrc; // copy ISRC into Cat No
          } else {
            clTrack.catalogue_number = "Unknown";
          }
        }
        oValData1.cueData.clearance_tracks.push(clTrack);
      }


      return {
        ...state,
        cueSheet: oValData1,
        selectedItems: selecteditems1,
        isTimeCodeSortUpdated: state.timeCodeSorting ? true : state.isTimeCodeSortUpdated
      };
    case actionTypes.SET_INVALID_TIMECODE:
      let oValData3 = { ...state.cueSheet };
      let item3 = state.items[state.items.findIndex(e => e.id == action?.payload?.id)];
      let track3 = item3.trackDetails;

      let extClearanceTrackIndex4 = oValData3.cueData?.clearance_tracks.findIndex(e => e.clearance_track_id == track3.id);
      if (oValData3.cueData?.clearance_tracks && state.selectedItem?.id == action?.payload?.id && extClearanceTrackIndex4 > -1) {
        if (oValData3.cueData.clearance_tracks[extClearanceTrackIndex4].clearance_track_usages[action?.payload?.index]) {
          oValData3.cueData.clearance_tracks[extClearanceTrackIndex4].clearance_track_usages[action?.payload?.index]["validTc"] = action?.payload?.value;
          oValData3.cueData.clearance_tracks[extClearanceTrackIndex4].clearance_track_usages[action?.payload?.index]["errorMsg"] = action?.payload?.message || "";
        }
      }

      return {
        ...state,
        cueSheet: oValData3,
      };
    case actionTypes.SET_INVALID_TIMECODE_CHILD:
      let oValData7 = { ...state.cueSheet };
      let item7 = state.items[state.items.findIndex(e => e.id == action?.payload?.id)];
      let track8 = item7.trackDetails;

      let extClearanceTrackIndex7 = oValData7.cueData?.clearance_tracks.findIndex(e => e.clearance_track_id == track8.id);
      if (oValData7.cueData?.clearance_tracks && state.selectedItem?.id == action?.payload?.id && extClearanceTrackIndex7 > -1) {
        let childUsageIndex = oValData7.cueData.clearance_tracks[extClearanceTrackIndex7].clearance_track_usages
          .findIndex(u => u.parentUsageUniqueId === action?.payload?.parentindex && u.parentUsageIndex == action?.payload.subindex);


        if (childUsageIndex > -1) {
          oValData7.cueData.clearance_tracks[extClearanceTrackIndex7].clearance_track_usages[childUsageIndex]["validTc"] = action?.payload?.value;
          oValData7.cueData.clearance_tracks[extClearanceTrackIndex7].clearance_track_usages[childUsageIndex]["errorMsg"] = action?.payload?.message || "";
        }
      }

      return {
        ...state,
        cueSheet: oValData7,
      };

    case actionTypes.REFRESH_CF:

      return {
        ...state,
        editing: {
          ...state.editing,
          ...action.payload.data,
        },
        items: action.payload.items,
      };

    case actionTypes.ERROR:
      return {
        ...state,
        loadingPage: false,
        errors: action.payload,
        editing: null,
      };

    case actionTypes.SELECT_ITEMS:
      return {
        ...state,
        selectedItems: action.payload,
      };
    case actionTypes.FOCUS_ITEM:
      return {
        ...state,
        selectedItem: action.payload,
      };
    case actionTypes.SET_SORTVALUE:
      return {
        ...state,
        sortValue: action.payload,
      };

    case actionTypes.REFRESH_ITEMS:


      return {
        ...state,
        items: action.payload,
        selectedItem: state.selectedItem ? action.payload.find(v => v.id === state.selectedItem.id) || action.payload[0] ? action.payload[0] : null : action.payload[0] ? action.payload[0] : null
      };
    case actionTypes.SORT_BY_TRACKTITLE:
      let dvalData = { ...state.cueSheet };
      let sortedItems = state.copyOfItems.sort((a, b) => a.trackDetails.trackTitle.localeCompare(b.trackDetails.trackTitle));
      dvalData.cueData.clearance_tracks.forEach(track => {
        track.clearance_track_usages = track.clearance_track_usages.filter(usage => {
          if (usage.parentUsageUniqueId && (usage.duration === "" || usage.duration === "00:00:00" || usage.duration === "00:NaN:NaN")) {
            return false;
          }
          return true;
        });
      });

      dvalData.cueData.clearance_tracks.forEach(track => {
        track.clearance_track_usages = track.clearance_track_usages.filter(usage => {

          const isParentNull = usage.parentUsageUniqueId === null || usage.parentUsageUniqueId === undefined;
          const isSubIndexNull = usage.usageSubIndex === null || usage.usageSubIndex === undefined;

          const dur = usage.duration || "";
          const isBadDuration =
            dur === "00:00:00" ||
            dur === "00:00:" ||
            dur === "00::" ||
            dur.includes("NaN");


          if (isParentNull && isSubIndexNull && isBadDuration) {
            return false;  // Remove this usage
          }

          return true; // Keep usage
        });

        const hasBlankUsage = track.clearance_track_usages.some(usage => usage.duration === "");
        if (!hasBlankUsage) {
          const societyIndicator = track.clearance_track_usages.length > 0
            ? track.clearance_track_usages[0].society_indicator
            : 0;

          const blankUsage = {
            description: "",
            duration: "",
            occurrences: "1",
            start_time: "",
            end_time: "",
            society_indicator: societyIndicator,
          };
          track.clearance_track_usages.push(blankUsage);
        }
      });

      dvalData.cueData.clearance_tracks.forEach(track => {
        if (Array.isArray(track.clearance_track_usages)) {
          track.clearance_track_usages.forEach(usage => {
            if ("parentUsageUniqueId" in usage) {
              usage.parentUsageUniqueId = null;
            }
            if ("usageSubIndex" in usage) {
              usage.usageSubIndex = null;
            }
            if ("parentUsageIndex" in usage) {
              usage.parentUsageIndex = null;
            }
          });
        }
      });


      return {
        ...state,
        items: sortedItems,
        timeCodeSorting: false,
        isTimeCodeSortUpdated: false,
        timecodeSortedItems: [],
        cueSheet: dvalData,
      };
    case actionTypes.SORT_BY_TIMECODE:
      let oValCueSheetData = state.cueSheet;
      let dOvalData = { ...state.cueSheet };
      let globalStartMap = new Map();
      const pTracks = (oValCueSheetData.cueData && oValCueSheetData.cueData.clearance_tracks) || [];

      pTracks.forEach((track, tIndex) => {
        track.clearance_track_usages.forEach((usage, uIndex) => {
          const secs = timeToSeconds(usage.start_time);
          if (secs != null) {
            if (!globalStartMap.has(secs)) {
              globalStartMap.set(secs, []);
            }
            globalStartMap.get(secs).push({ trackIndex: tIndex, usageIndex: uIndex, trackid: track.clearance_track_id });
          }
        });
      })
      // ✅ reset helper fields before processing
      oValCueSheetData.cueData.clearance_tracks.forEach(track => {
        if (Array.isArray(track.clearance_track_usages)) {
          track.clearance_track_usages.forEach(usage => {
            delete usage.parentUsageUniqueId;
            delete usage.usageSubIndex;
            delete usage.parentUsageIndex;
            delete usage.isSequential;
            delete usage._startTimeSeconds;
            delete usage.usageUniqueId;
          });
        }
      });
      const sortedUsageTracks = oValCueSheetData.cueData?.clearance_tracks.map((track, ii) => {
        const trackId = track.clearance_track_id;

        let sortedUsages = track.clearance_track_usages
          .map((usage, i) => {
            const secs = timeToSeconds(usage.start_time);
            // return secs !== null ? { ...usage, _startTimeSeconds: secs, usageUniqueId: `${trackId}_${i}` } : null;
            if (secs === null) return null;


            const usageUniqueId = `${trackId}_${i}`;
            const usageObj = {
              ...usage,
              _startTimeSeconds: secs,
              usageUniqueId,
              isSequential: false,            // default
              parentUsageUniqueId: null,
              parentUsageIndex: i
            };
            usageObj.parentUsageUniqueId = null;
            return usageObj;
          })
          .filter(Boolean) // remove invalid start times
        // (e.isSequential == undefined || e.isSequential != true)

        // --- detect sequential usages ---
        let currentParent = null;
        sortedUsages = sortedUsages.sort((a, b) => a._startTimeSeconds - b._startTimeSeconds);
        for (let i = 1; i < sortedUsages.length; i++) {
          const prev = sortedUsages[i - 1];
          const curr = sortedUsages[i];

          const prevStart = prev._startTimeSeconds;
          const prevEnd = timeToSeconds(prev.end_time);
          const currStart = curr._startTimeSeconds;

          if (i === 0) {
            // first usage → new sequence
            curr.isSequential = false;
            curr.parentUsageUniqueId = null;
            currentParent = curr.usageUniqueId;
            continue;
          }
      

        // Check if another track has a usage start time between prevEnd and currStart
    const hasInterveningOtherTrack = [...globalStartMap.keys()].some(time => {
      return time > prevEnd && time < currStart && globalStartMap.get(time).some(e => e.trackIndex !== ii);
    });
          if (
            prevEnd !== null && currStart !== null && !hasInterveningOtherTrack
          ) {
            // start a new sequence if not already
            if (!currentParent) {
              currentParent = prev.usageUniqueId;
              prev.isSequential = false;
              prev.parentUsageUniqueId = null;
            }

            if(prevStart && globalStartMap.get(prevStart).some(e => e.trackIndex !== ii)){
              oValCueSheetData.cueData.clearance_tracks[ii].clearance_track_usages[curr.parentUsageIndex].parentUsageUniqueId = null;
              oValCueSheetData.cueData.clearance_tracks[ii].clearance_track_usages[curr.parentUsageIndex].isSequential = false;
              oValCueSheetData.cueData.clearance_tracks[ii].clearance_track_usages[curr.parentUsageIndex].parentUsageIndex = i;
              oValCueSheetData.cueData.clearance_tracks[ii].clearance_track_usages[curr.parentUsageIndex]._startTimeSeconds = curr._startTimeSeconds;
              currentParent = null;
            }
            else{
              curr.isSequential = true;
              curr.parentUsageUniqueId = currentParent;
              oValCueSheetData.cueData.clearance_tracks[ii].clearance_track_usages[curr.parentUsageIndex].parentUsageUniqueId = currentParent;
              oValCueSheetData.cueData.clearance_tracks[ii].clearance_track_usages[curr.parentUsageIndex].isSequential = true;
              oValCueSheetData.cueData.clearance_tracks[ii].clearance_track_usages[curr.parentUsageIndex].parentUsageIndex = i;
              oValCueSheetData.cueData.clearance_tracks[ii].clearance_track_usages[curr.parentUsageIndex]._startTimeSeconds = curr._startTimeSeconds;
            }
            
          } else {
            // break sequence
            oValCueSheetData.cueData.clearance_tracks[ii].clearance_track_usages[curr.parentUsageIndex].parentUsageUniqueId = null;
            oValCueSheetData.cueData.clearance_tracks[ii].clearance_track_usages[curr.parentUsageIndex].isSequential = false;
            oValCueSheetData.cueData.clearance_tracks[ii].clearance_track_usages[curr.parentUsageIndex].parentUsageIndex = i;
            oValCueSheetData.cueData.clearance_tracks[ii].clearance_track_usages[curr.parentUsageIndex]._startTimeSeconds = curr._startTimeSeconds;
            currentParent = null;
          }
        }

     
        const flattened = sortedUsages.flat();


        sortedUsages.forEach(e => {
          const hasBlankUsage = oValCueSheetData.cueData.clearance_tracks[ii].clearance_track_usages.some(
            usage => usage.parentUsageUniqueId === e.usageUniqueId
          );

          // if (!hasBlankUsage) {
          const blankUsage = {
            description: "",
            duration: "",
            occurrences: "1",
            start_time: "",
            end_time: "",
            society_indicator: e.society_indicator ?? 0,
            parentUsageUniqueId: e.usageUniqueId,
            parentUsageIndex: oValCueSheetData.cueData.clearance_tracks[ii].clearance_track_usages.length + 1,
            usageSubIndex: oValCueSheetData.cueData.clearance_tracks[ii].clearance_track_usages.length + 1,
            validTc: null,
            errorMsg: ""
          };
          oValCueSheetData.cueData.clearance_tracks[ii].clearance_track_usages.push(blankUsage);
          // }
        })
        // 🔄 assign back sorted usages to original track
        oValCueSheetData.cueData.clearance_tracks[ii].clearance_track_usages = oValCueSheetData.cueData.clearance_tracks[ii].clearance_track_usages.sort((a, b) => a._startTimeSeconds - b._startTimeSeconds);
        return {
          clearance_track_id: trackId,
          track_title: track.track_title,
          sorted_clearance_track_usages: flattened
        };
      }).filter(track => track.sorted_clearance_track_usages.length > 0);

      const newItems = sortedUsageTracks.flatMap(track =>
        track.sorted_clearance_track_usages.map(usage => ({
          clearance_track_id: track.clearance_track_id,
          track_title: track.track_title,
          album_title: track.album_title,
          ...usage
        }))
      );

      const allTrackMap = Object.fromEntries(
        state.copyOfItems.map(track => [track.trackDetails.id, track])
      );

      const enrichedItems = newItems.map(item => {
        const matchingTrack = allTrackMap[item.clearance_track_id];
        return {
          ...item,
          ...(matchingTrack || {}) // safely merge if found
        };
      }).filter(e => ((e.validTc == true || (e.added == true && e.start_time != "" && e.end_time != "") ||
        (
          e.duration !== "00:00:00" &&
          e.duration !== "00:00:" &&
          e.duration !== "00::" &&
          !e.duration.includes("NaN") &&
          e.start_time != "" &&
          e.end_time != "" &&
          e.validTc == true)) && ((e.isSequential == undefined || e.isSequential != true) && e.start_time != "" &&
            e.end_time != ""))).sort((a, b) => a._startTimeSeconds - b._startTimeSeconds);


      return {
        ...state,
        items: enrichedItems,
        copyOfItems: state.copyOfItems,
        timeCodeSorting: true,
        cueSheet: dOvalData,
      };
    case actionTypes.RE_SORT_TIMECODE:
      let qData = { ...state.cueSheet };

      if (qData.cueData?.clearance_tracks) {
        qData.cueData.clearance_tracks.forEach(track => {
          if (Array.isArray(track.clearance_track_usages)) {
            track.clearance_track_usages.forEach(usage => {
              delete usage.parentUsageUniqueId;
              delete usage.usageSubIndex;
              delete usage.parentUsageIndex;
              delete usage.isSequential;
              delete usage._startTimeSeconds;
              delete usage.usageUniqueId;
            });
          }
        });
      }

      qData.cueData.clearance_tracks.forEach((track) => {
        // Filter usages based on your criteria:
        track.clearance_track_usages = track.clearance_track_usages.filter(usage => {

          const dur = usage.duration || "";
          const isBadDuration =
            dur === "00:00:00" ||
            dur === "00:00:" ||
            dur === "00::" ||
            dur === "" ||
            dur.includes("NaN");

          if (isBadDuration) {
            return false; // remove
          }
          return true; // keep
        });
      });

      return {
        ...state,
        // items: enrichedItems,
        timeCodeSorting: true,
        isTimeCodeSortUpdated: false,
        cueSheet: qData,
      };
    case actionTypes.POSTING:
      return {
        ...state,
        posting: {
          busy: true,
          message: action.payload,
          errors: null,
          trackErrors: null
        },
      };

    case actionTypes.POST_OK:
      return {
        ...state,
        posting: {
          busy: false,
          message: "",
          errors: null,
          trackErrors: null
        },
        changedFields: [],
        changedTrackFields: [],
      };

    case actionTypes.POST_ERROR:
      return {
        ...state,
        posting: {
          busy: false,
          message: action.message ? action.message : action.payload,
          errors: action.payload,
          trackErrors: action?.trackErrors || null
        },
      };

    case actionTypes.SAVING_DATA:
      return {
        ...state,
        posting: {
          busy: true,
          message: action.payload,
          errors: null,
          trackErrors: null
        },
      };
    case actionTypes.SAVE_SUCCESS:

      let oValCueData = { ...state.cueSheet };

      if (state.timeCodeSorting) {
        action.payload.forEach(track => {
          const trackId = track.clearance_track_id;

          track.clearance_track_usages.forEach(payloadUsage => {
            oValCueData.cueData.clearance_tracks.forEach(item => {
              if (item.clearance_track_id === trackId) {
                item.clearance_track_usages = item.clearance_track_usages.map(existingUsage => {
                  const isSameUsage =
                    existingUsage.description === payloadUsage.description &&
                    existingUsage.start_time === payloadUsage.start_time &&
                    existingUsage.occurrences === payloadUsage.occurrences &&
                    existingUsage.duration === payloadUsage.duration &&
                    existingUsage.end_time === payloadUsage.end_time;

                  if (isSameUsage) {
                    return { ...existingUsage, added: true, isLocal: false };
                  }
                  return existingUsage;
                });
              }
            });
          });
        });

      }
      else {
        action.payload.forEach(track => {
          const trackId = track.clearance_track_id;

          oValCueData.cueData.clearance_tracks.forEach(item => {
            if (item.clearance_track_id === trackId) {
              // Iterate through clearance_track_usages
              item.clearance_track_usages = item.clearance_track_usages.map(usage => {
                const isValid =
                  usage.duration &&
                  usage.duration !== "00:00:00" &&
                  usage.duration !== "00:00:" &&
                  !usage.duration.includes("NaN") &&
                  usage.occurrences !== "";
                return {
                  ...usage,
                  added: isValid ? true : usage.added,
                  isLocal: false
                };
              });
            }
          });
        });
      }

      oValCueData.clearance_tracks = oValCueData.cueData.clearance_tracks.map(track => ({
        clearance_track_id: track.clearance_track_id,
        clearance_track_usages: track.clearance_track_usages
      }));

      return {
        ...state,
        cueSheet: oValCueData,
      };

    case actionTypes.SAVING_DATA_LOCAL:

      return {
        ...state,
        postingLocal: {
          busy: true,
          message: action.payload,
          errors: null,
        },
      };
    case actionTypes.POST_OK_LOCAL:
      let sValCueData = { ...state.cueSheet };
      if (
        (!sValCueData.clearance_tracks || sValCueData.clearance_tracks.length === 0) &&
        sValCueData.cueData?.clearance_tracks?.length > 0
      ) {
        sValCueData.clearance_tracks = sValCueData.cueData.clearance_tracks.map(track => ({
          clearance_track_id: track.clearance_track_id,
          clearance_track_usages: track.clearance_track_usages
        }));
      }
      return {
        ...state,
        cueSheet: sValCueData,
        postingLocal: {
          busy: false,
          message: null,
          errors: null,
        },
      };
    case actionTypes.POST_ERROR_LOCAL:
      return {
        ...state,
        postingLocal: {
          busy: false,
          message: action.payload,
          errors: action.payload,
        },
      };


    case actionTypes.CLEAR_ERRORS:
      return {
        ...state,
        posting: {
          ...state.posting,
          // errors: null,
          // errors: action.payload,
          errors: null,
          trackErrors: null
        },
      };
    case actionTypes.RE_SORT_TIMECODE_UPDATE_DONE:
      return {
        ...state,
        shouldTimeCodeSortUpdate: false
      };


    case actionTypes.PREVIEW_TAB:
      return {
        ...state,
        activePreview: action.payload,
      };

    case actionTypes.LOADING_CFTRACKS:
      return {
        ...state,
        cfTracksLoading: true
      }
    case actionTypes.LOAD_CFTRACKS:
      if (action.payload.cfId in state.cfTracks) {
        state.cfTracks[action.payload.cfId][action.payload.trackId] = action.payload.cfTrackData;
      }
      else {
        state.cfTracks[action.payload.cfId] = {};
        state.cfTracks[action.payload.cfId][action.payload.trackId] = action.payload.cfTrackData;
      }
      return {
        ...state,
        cfTracksLoading: false
      };
    case actionTypes.LOADING_TRACKS:
      return {
        ...state,
        tracksPosting: {
          busy: true,
          message: "Loading Tracks..",
          errors: null
        },
        items: [],
        loading: true,
        // totalItems: 0
      };

    case actionTypes.LOAD_TRACKS:

      let tracks = [];
      let sData = state.cueSheet;
      let lists = action.payload.items;
      lists.forEach(i => {
        let track = i.trackDetails;
        tracks.push(track)

      })
      if (tracks.length > 0) {
        sData['cueData'] = {
          clearance_tracks: []
        };

        tracks.forEach(i => {
          let track = i;
          let cfTrack = lists[lists.findIndex(e => e.trackDetails.id == i.id)];
          let newTrack = {
            clearance_track_id: track.id,
            clearance_track_usages: [
              {
                description: "",
                duration: "",
                occurrences: "1",
                start_time: "",
                end_time: "",
                society_indicator: getSocietyIndicator(cfTrack),
              },
            ],
            track_title: track.prsTrack?.trackTitle || track.trackTitle,
            composers: track.prsTrack?.composer || track.composer || [],
            publishers: track.prsTrack?.publisher || track.publisher || [],
            performers: track.prsTrack?.performer || track.performer || [],
            isrc: track.prsTrack?.isrc || track.isrc,
            iswc: track.iswc,
            catalogue_number: track.prsTrack?.catNo || track.catNo || "",
            arrangers: track.arranger,
            record_or_video_labels: track.prsTrack?.recordLabel || track.recordLabel,
            music_origin: getMusicOriginMappings(track.musicOrigin),
            cue_usage:
              cfTrack.trackUsage && cfTrack.trackUsage !== ""
                ? MBTrackUsageMapping.find(e => cfTrack.trackUsage === e.value)?.MLMapping || "F"
                : "F",
            mcps_status:
              track.org_sky_MCPS === true
                ? "CH"
                : track.org_sky_MCPS === false
                  ? "UC"
                  : "UK",
            album_title: track.prodName || "",
            album_id: track.id || "",
            library_id: track.libId || "",
            library_name: track.libName || "",
          };
          // Apply Cat No fallback rule
          if (
            validOriginForCatNoChange.includes(newTrack.music_origin) &&
            (!newTrack.catalogue_number || newTrack.catalogue_number.trim() === "")
          ) {
            if (newTrack.isrc && newTrack.isrc.trim() !== "") {
              newTrack.catalogue_number = newTrack.isrc; // copy ISRC into Cat No
            } else {
              newTrack.catalogue_number = "Unknown";
            }
          }
          // Push after adjustments
          sData.cueData.clearance_tracks.push(newTrack);
        })

        // Render already added cue sheet data
        if (sData.clearance_tracks.length > 0) {
          sData.clearance_tracks.forEach(tr => {
            let index = sData.cueData.clearance_tracks.findIndex(s => s.clearance_track_id == tr.clearance_track_id);
            if (index != -1 && sData.cueData.clearance_tracks[index]) {
              tr.clearance_track_usages = tr.clearance_track_usages
                .map(i => ({
                  ...i,
                  added: i?.isLocal ? false : true,
                  duration: getDurationValue(durationPickerType.MMSS, getTimeToSeconds(i.duration))
                }))
                .filter(u => {

                  const isLocalDummy =
                    !u.validTc &&
                    u.start_time &&
                    u.end_time &&
                    u.errorMsg;

                  if (isLocalDummy) return true;

                  const badDuration =
                    !u.duration ||
                    u.duration.includes("NaN") ||
                    u.duration === "00:00:00" ||
                    u.duration === "00:00:" ||
                    u.duration === "00::";

                  return !(badDuration);
                });

              if (tr.clearance_track_usages.filter(ii => ii.added == true)?.length == tr.clearance_track_usages.length) {
                tr.clearance_track_usages.push(
                  {
                    "description": "",
                    "duration": "",
                    "occurrences": "1",
                    "start_time": "",
                    "end_time": "",
                    "society_indicator": getSocietyIndicator(tr)
                  }
                );
              }
              else if (tr.clearance_track_usages.filter(ii => ii.duration == "")?.length == 0) {
                tr.clearance_track_usages.push(
                  {
                    "description": "",
                    "duration": "",
                    "occurrences": "1",
                    "start_time": "",
                    "end_time": "",
                    "society_indicator": getSocietyIndicator(tr)
                  }
                );
              }
              sData.cueData.clearance_tracks[index] = { ...sData.cueData.clearance_tracks[index], clearance_track_usages: tr.clearance_track_usages };
            }
          })
        }
      }


      return {
        ...state,
        tracksPosting: {
          busy: false,
          message: "",
          errors: null
        },
        items: action.payload.items,
        copyOfItems: action.payload.items,
        totalItems: action.payload.totalItems,
        loading: false,
        cueSheet: sData,
        timeCodeSorting: false,
        isTimeCodeSortUpdated: false,
        // sortValue: ""
      };
    case actionTypes.ERROR_TRACKS:
      return {
        ...state,
        tracksPosting: {
          busy: false,
          message: "",
          errors: action.payload
        },
        items: [],
        totalItems: 0,
        loading: false
      };
    case actionTypes.QUERY:
      return {
        ...state,
        query: action.payload,
      };

    default:
      return state;
  }
}
